<template>
    <div :class="{'simple-horizontal-layout': horizontal, 'simple-vertical-layout': vertical}">
        <slot/>
    </div>
</template>

<script>
    export default {
        name: "SimpleLayout",
        props: {
            vertical: Boolean,
            horizontal: Boolean
        },
        data: function () {
            return {}
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/global";
    .simple-horizontal-layout {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(20px, auto));
        grid-auto-rows: minmax(20px, auto);
        grid-gap: 20px;
        position: relative;
    }

    .simple-vertical-layout {
        display: grid;
        grid-template-rows: repeat(auto-fit, minmax(20px, auto));
        grid-auto-columns: 1fr;
        grid-gap: 20px;
        position: relative;
    }

</style>